import { Input, InputProps } from '@chakra-ui/react';
import React from 'react';

type DebouncedInputProps = Omit<InputProps, 'onChange' | 'value'> & {
  debounce?: number;
  value?: string | number;
  onChange: (value: string | number) => void
} 
// A typical debounced input react component
export default function DebouncedInput({
  value: initialValue = '',
  onChange,
  debounce = 500,
  ...props
}: DebouncedInputProps) {
  const [value, setValue] = React.useState(initialValue);
  const onChangeRef = React.useRef(onChange);

  React.useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChangeRef.current(value)
    }, debounce);

    return () => clearTimeout(timeout)
  }, [value, debounce]);

  return (
    <Input {...props} value={value} onChange={e => setValue(e.target.value)} />
  )
}